<template>
    <div>
        <dictionary-simple-table
        dictionary_link = "/product-code-types"
        title = "Lista typów kodu"
        :numeral_text = "['typ kodu', 'typy kodu', 'typów kodu']"
        :columns_title = "['name']"
        ></dictionary-simple-table>
    </div>
</template>

<script>
    import DictionarySimpleTable from './DictionarySimpleTable.vue';
    export default {
        components: {
            DictionarySimpleTable
        },
    }
</script>